"use client";

import React from "react";
import {
  XIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  FacebookShareButton,
  FacebookIcon,
  FacebookShareCount,
  TelegramShareButton,
  TelegramIcon,
  EmailIcon,
  EmailShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
} from "react-share";

export default function SocialShare({
  url,
  imgUrl,
  title,
}: {
  url: string;
  imgUrl: string;
  title: string;
}) {
  const size = 34;
  const borderRadius = 20;

  return (
    <div className="flex flex-wrap items-center gap-1">
      <p>Share: </p>
      <FacebookShareButton
        aria-label="facebook share button"
        url={url}
        hashtag="starlinkinfo"
      >
        <FacebookIcon size={size} borderRadius={borderRadius} />
      </FacebookShareButton>
      <TwitterShareButton
        aria-label="twitter share button"
        url={url}
        title={title}
        hashtags={["StarlinkInfo,Starlink"]}
        via="starlinkinfo"
      >
        <XIcon size={size} borderRadius={borderRadius} />
      </TwitterShareButton>
      <WhatsappShareButton
        aria-label="whatsapp share button"
        url={url}
        title={title}
        separator=" 🚀 "
      >
        <WhatsappIcon size={size} borderRadius={borderRadius} />
      </WhatsappShareButton>
      <TelegramShareButton
        aria-label="telegram share button"
        url={url}
        title={title}
      >
        <TelegramIcon size={size} borderRadius={borderRadius} />
      </TelegramShareButton>
      <LinkedinShareButton
        aria-label="linkedin share button"
        url={url}
        title={title}
      >
        <LinkedinIcon size={size} borderRadius={borderRadius} />
      </LinkedinShareButton>
      <PinterestShareButton
        aria-label="pinterest share button"
        url={url}
        media={imgUrl}
        description={title}
      >
        <PinterestIcon size={size} borderRadius={borderRadius} />
      </PinterestShareButton>
      <FacebookShareCount url={url} />
      <EmailShareButton
        aria-label="email share button"
        url={url}
        subject={title}
        body={`Check out this article: ${title}`}
      >
        <EmailIcon size={size} borderRadius={borderRadius} />
      </EmailShareButton>
    </div>
  );
}
